export default __webpack_public_path__ + "static/media/fully_reg_det_topology_full.605141bc.png";